import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchEntity } from '../../domain/entities/BranchEntity'
import type { BranchAdminDto } from '@/backend/market'
import { BranchDeliverySettingMiniModel } from '@/features/branchDeliverySetting/data/models/BranchDeliverySettingMiniModel'
import { BranchMinimumCartSystemMiniModel } from '@/features/branchMinimumCartSystem/data/models/BranchMinimumCartSystemMiniModel'

export class BranchModel extends BranchEntity {
  constructor(dataDto: BranchAdminDto) {
    super()
    const branchDeliveryModels = dataDto.deliverySystems?.map(
      (deliverySystem) =>
        new BranchDeliverySettingMiniModel(deliverySystem as unknown as BranchDeliverySettingMiniModel)
    )
    const minimumCartSystemModel = dataDto.minimumCartSystem
      ? new BranchMinimumCartSystemMiniModel(dataDto.minimumCartSystem)
      : null
    mapEntityProperties<BranchModel>(this, dataDto, {
      exclude: ['brand', 'channel', 'service'],
      map: {
        brand: {
          name: dataDto.brandName,
          id: dataDto.brandId
        },
        channel: {
          name: dataDto.channelName,
          id: dataDto.channelId
        },
        service: dataDto.service,
        branchDeliverySystems: branchDeliveryModels,
        minimumCartSystem: minimumCartSystemModel,
        relatedChannels: dataDto.relatedChannels?.map((item) => {
          return {
            id: item.channelId,
            name: item.channelName
          }
        })
      }
    })
  }
}
